export default __webpack_public_path__ + "static/video-thumbnail-6d8bff8d313e79d6cc298079298eba56.png";